import React from "react";
import { FooterStyles } from "./Styles";

const Footer = () => {
  return (
    <FooterStyles>
      <h4>CryptAdda, &copy; 2022</h4>
    </FooterStyles>
  );
};

export default Footer;
